export const chargingTransactionActionTypes = {
    SET_CHARGING_TRANSACTION: "SET_CHARGING_TRANSACTION",
  };
  